export const HEADER_HEIGHT = 88
export const HEADER_HEIGHT_MD = 60
export const HEADER_HEIGHT_SM = 48

export enum ENTRIES_VIEW_MODE {
  TABLE = 'table',
  GRID = 'grid',
}
